import React from 'react'

const EditDealerForm = () => {
    return (
        <div>EditDealerForm</div>
    )
}

export default EditDealerForm